export default function daysBetween(date1, date2) {

    // adjust diff for for daylight savings
    let hoursToAdjust = Math.abs(date1.getTimezoneOffset() /60) - Math.abs(date2.getTimezoneOffset() /60);
    // apply the tz offset
    let date3 = new Date(date2)
    date3.setHours(date2.getHours() + hoursToAdjust);

    // The number of milliseconds in one day
    let ONE_DAY = 1000 * 60 * 60 * 24

    // Convert both dates to milliseconds
    let date1_ms = date1.getTime()
    let date3_ms = date3.getTime()

    // Calculate the difference in milliseconds
    let difference_ms = (date3_ms - date1_ms)

    // Convert back to days and return
    return Math.round(difference_ms/ONE_DAY)
}
